import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet<UseLicensesListQueryParams>('licenses');

type UseLicensesListQueryParams = Parameters<typeof SSF.api.licensesList>[0];

export function useLicensesListQuery(params: UseLicensesListQueryParams = {}, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.licensesList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}

export function useLicenseQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.licensesRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
